export default __webpack_public_path__ + "static/media/guide-on.3c87b265.svg";